export default __webpack_public_path__ + "data/NUTS_RG_20M_2016_3857_LEVL_3.topojson";